export const GA = 'UA-119717465-9';
